import { graphql, HttpResponse } from 'msw'
import {
  Month,
  LegalDocumentPartner,
  type CustomerStatementsOutput,
  type CustomerStatementsDatesOutput,
  type CustomerTaxDocumentsOutput,
  type CustomerLegalDocumentsOutput,
  type CustomerLegalDocumentPartnersOutput,
  type InvestmentTradeConfirmLinkOutput,
} from '../../models'

export const customerStatementsDates: CustomerStatementsDatesOutput = {
  statementsDates: [
    {
      year: '2025',
      months: [Month.JULY, Month.JUNE, Month.MAY, Month.APRIL, Month.MARCH, Month.FEBRUARY, Month.JANUARY],
    },
    {
      year: '2024',
      months: [Month.DECEMBER, Month.NOVEMBER],
    },
  ],
}

export const mockGetCustomerStatementsDatestHandler = graphql.query('customerStatementsDates', () => {
  return HttpResponse.json({ data: { customerStatementsDates } })
})

export const customerStatements: CustomerStatementsOutput = {
  statements: [
    {
      name: 'name',
      url: 'url',
      rank: 2,
    },
  ],
}

export const mockGetCustomerStatementstHandler = graphql.query('customerStatements', () => {
  return HttpResponse.json({ data: { customerStatements } })
})

export const customerTaxDocuments: CustomerTaxDocumentsOutput = {
  documents: [
    {
      name: 'name',
      url: 'url',
      rank: 2,
    },
  ],
}

export const mockGetCustomerTaxDocumentsHandler = graphql.query('customerTaxDocuments', () => {
  return HttpResponse.json({ data: { customerTaxDocuments } })
})

export const customerLegalDocuments: CustomerLegalDocumentsOutput = {
  documents: [
    {
      name: 'name',
      url: 'url',
      rank: 2,
    },
  ],
}

export const mockGetCustomerLegalDocumentsHandler = graphql.query('customerLegalDocuments', () => {
  return HttpResponse.json({ data: { customerLegalDocuments } })
})

export const customerLegalDocumentPartners: CustomerLegalDocumentPartnersOutput = {
  partners: [LegalDocumentPartner.DRIVEWEALTH, LegalDocumentPartner.EVERGREEN_WEALTH_ADVISORS],
}

export const mockGetCustomerLegalDocumentPartnersHandler = graphql.query('customerLegalDocumentPartners', () => {
  return HttpResponse.json({ data: { customerLegalDocumentPartners } })
})

export const investmentTradeConfirmLinkOutputMock: InvestmentTradeConfirmLinkOutput = {
  confirm: {
    url: 'https://google.com',
  },
}

export const mockGetInvestmentTradeConfirmLinkHandler = graphql.query('investmentTradeConfirmLink', () => {
  return HttpResponse.json({ data: { investmentTradeConfirmLink: investmentTradeConfirmLinkOutputMock } })
})

export const mockDocument = [
  mockGetCustomerStatementsDatestHandler,
  mockGetCustomerLegalDocumentPartnersHandler,
  mockGetCustomerStatementstHandler,
  mockGetCustomerLegalDocumentsHandler,
  mockGetCustomerTaxDocumentsHandler,
  mockGetInvestmentTradeConfirmLinkHandler,
]
